import {IComponentOptions} from 'angular';
import {IStateService} from 'angular-ui-router';
import {IAuthenticationStateParams} from '../../authentication.route';
import ErrorService from '../../../core/errors/service/ErrorService';
import BenutzerRS from '../../../core/service/BenutzerRS.rest';
import IWindowService = angular.IWindowService;
import IHttpParamSerializer = angular.IHttpParamSerializer;
import ITimeoutService = angular.ITimeoutService;
import ILocationService = angular.ILocationService;
import ILogService = angular.ILogService;
import IFormController = angular.IFormController;
import ITranslateService = angular.translate.ITranslateService;
let template = require('./passwordResetView.html');
require('./passwordResetView.scss');

export class PasswordResetComponentConfig implements IComponentOptions {
    transclude = false;
    template = template;
    controller = PasswordResetViewController;
    controllerAs = 'vm';
}

export class PasswordResetViewController {

    static $inject: string[] = ['$state', '$stateParams', '$window', '$httpParamSerializer', '$timeout', 'BenutzerRS'
        , '$location', '$log', 'ErrorService', 'CONSTANTS', '$translate'];

    private email: string;
    private form: IFormController;

    constructor(private $state: IStateService, private $stateParams: IAuthenticationStateParams,
                private $window: IWindowService, private $httpParamSerializer: IHttpParamSerializer,
                private $timeout: ITimeoutService, private benutzerRS: BenutzerRS, private $location: ILocationService,
                private $log: ILogService, private errorService: ErrorService, private CONSTANTS: any,
                private $translate: ITranslateService) {

    }

    $onInit() {

    }

    public resetClicked() {
        this.errorService.clearError('ERROR_LOGIN');
        if (this.form.$valid) {
            this.benutzerRS.createAndSendPasswordResetToken(this.email)
                .then(() => {
                    let successmsg = this.$translate.instant('LOGIN_PW_REST_SENT');   //wir bekommen immer success zurueck
                    this.errorService.addMesageAsInfo(successmsg)

                });

        } else {
            this.$log.debug('Form was not valid');
        }

    }

}



// WEBPACK FOOTER //
// ./src/app/authentication/component/passwordResetView/passwordResetView.ts